import { SyntheticEvent, useState } from "react";
import { Box, Button, Form } from "react-bulma-components";
import { useSendPasswordResetEmail } from "react-firebase-hooks/auth";
import { useTranslation } from "react-i18next";
import { fbAuth } from "../../../firebase";
import { ModalProps } from "../ModalManager";

export function ResetPasswordModal({ ...props }: ModalProps) {
  const { t, i18n } = useTranslation();

  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [sendPasswordResetEmail, sending, error] = useSendPasswordResetEmail(fbAuth);

  const handleResetPassword = async (e: SyntheticEvent) => {
    e.preventDefault();
    await sendPasswordResetEmail(email);
    setEmailSent(true);
    await new Promise(resolve => setTimeout(resolve, 1000));
    props.closeModal();
  }

  return (
    <Box>
      <p className="title">{t("password-reset.title")}</p>
      <p className="subtitle">{t("password-reset.description")}</p>
      <form>
        <Form.Field>
          <Form.Label>{t("email")}</Form.Label>
          <Form.Control>
            <Form.Input
              type="email"
              autoFocus={true}
              placeholder="abc@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)} />
          </Form.Control>
          {emailSent && <p className="help is-success">{t("password-reset.success")}</p>}
        </Form.Field>

        <Form.Field className="is-grouped">
          <Form.Control>
            <Button color="info"
              onClick={handleResetPassword}
              loading={sending}
              disabled={sending || emailSent}
            >
              {t("password-reset.button-title.reset")}
            </Button>
          </Form.Control>

          <Form.Control>
            <Button className="is-ghost has-text-info" disabled={sending} onClick={props.closeModal}>
              {emailSent ? t("close") : t("cancel")}
            </Button>
          </Form.Control>
        </Form.Field>
      </form>
    </Box>
  )
}